import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=56bd6a9b&scoped=true&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update.vue?vue&type=style&index=0&lang=css&"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=56bd6a9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd6a9b",
  null
  
)

export default component.exports